
export default {
  props: {
    member: { type: Object, required: true },
    isSelected: { type: Boolean, default: false },
  },
}
